import i18n from 'i18next'
import XHR from 'i18next-xhr-backend'
import LanguageDetector from 'i18next-browser-languagedetector'
import { initReactI18next } from 'react-i18next'
import 'dayjs/locale/en'
import 'dayjs/locale/es'
import 'dayjs/locale/fr'
import 'dayjs/locale/it'
import 'dayjs/locale/nl'
import 'dayjs/locale/pt'
import 'dayjs/locale/pt-br'
import 'dayjs/locale/uk'

i18n
  .use(XHR)
  .use(LanguageDetector)
  .use(initReactI18next) // bind react-i18next to the instance
  .init({
    fallbackLng: 'en',
    debug: false,
    lowerCaseLng: true,
    supportedLngs: ['en', 'es', 'fr', 'it', 'nl', 'pt', 'pt-br', 'uk'],
    nonExplicitSupportedLngs: true,
    interpolation: {
      escapeValue: false // not needed for react!!
    },
    // react i18next special options (optional)
    // override if needed - omit if ok with defaults
    react: {
      bindI18n: 'languageChanged',
      bindI18nStore: '',
      transEmptyNodeValue: '',
      transSupportBasicHtmlNodes: true,
      transKeepBasicHtmlNodesFor: ['br', 'strong', 'i'],
      useSuspense: false
    }
  })
  .then(() => {
    const detectedLng = i18n.language
    const normalizeLanguage = (lng) => {
      if (!lng) return lng
      if (lng.startsWith('pt')) {
        return lng === 'pt-br' ? 'pt-br' : 'pt'
      }
      const baseLng = lng.split('-')[0]
      if (
        baseLng &&
        baseLng !== lng &&
        Array.isArray(i18n.options.supportedLngs) &&
        i18n.options.supportedLngs.includes(baseLng)
      ) {
        return baseLng
      }
      return lng
    }

    const resolvedLng = normalizeLanguage(detectedLng)
    if (resolvedLng && resolvedLng !== detectedLng) {
      i18n.changeLanguage(resolvedLng)
    }
  })

export default i18n
